<template>
  <v-dialog
    v-model="dialogVisible"
    :persistent="persistent !== undefined ? persistent : showLoading"
    :max-width="width"
    scrollable
    :overlay-opacity="this.overlayOpacity"
    >
    <v-card class="a-dialog-card" :data-cy="name + '-dialog'">
      <v-toolbar v-if="toolbar" dark color="primary">
        <v-toolbar-title>
          <slot name="title"></slot>
        </v-toolbar-title>
        <v-spacer></v-spacer>
        <v-toolbar-items>
          <v-btn icon dark @click="dialogVisible = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-toolbar-items>

        <v-progress-linear
          v-if="!toolbarTab"
          :active="progress === true"
          :indeterminate="true"
          absolute
          bottom
          color="white">
        </v-progress-linear>

        <template v-slot:extension v-if="toolbarTab">
          <v-tabs v-model="tab" align-with-title>
            <v-tabs-slider :color="progress ? 'primary' : 'white'"></v-tabs-slider>
            <v-tab v-for="item in toolbarTab" :key="item">
              {{ item }}
            </v-tab>
          </v-tabs>

          <v-progress-linear :active="progress === true" :indeterminate="true" absolute bottom color="white">
          </v-progress-linear>
        </template>
      </v-toolbar>
      <v-card-title v-else class="headline">
        <slot name="title"></slot>
        <v-spacer v-if="$slots['title-right']"></v-spacer>
        <slot v-if="$slots['title-right']" name="title-right"></slot>
      </v-card-title>

      <v-card-text :class="getCardClasses()">
        <a-loader :enabled="showLoading" :text="loadingText" :progress="loadingProgress"></a-loader>
        <div v-show="showLoading" style="height: 100px;"></div>
        <div v-if="dialogVisible" v-show="!showLoading">
          <slot name="content"></slot>
        </div>
      </v-card-text>
      <v-card-actions v-if="actions !== false">
        <v-spacer v-if="spacerAction !== false"></v-spacer>
        <v-btn v-if="closeAction !== false" color="grey" text @click="close()">
          {{ !$slots['actions'] ? $t('actions.close') : $t('actions.cancel') }}
        </v-btn>
        <slot name="actions" v-bind:todo="{ close }"></slot>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: 'ADialog',
  props: [
    'visible',
    'name',
    'toolbar',
    'toolbar-tab',
    'loading',
    'loading-progress',
    'progress',
    'size',
    'actions',
    'spacer-action',
    'close-action',
    'dense',
    'persistent',
    'overlayOpacity'
  ],
  data () {
    return {
      dialogVisible: false,
      tab: null
    }
  },
  watch: {
    dialogVisible (dialogVisible) {
      if (dialogVisible === false) {
        this.close()
      }
    },
    visible () {
      this.handleVisibleProp()
    },
    tab (value) {
      this.$emit('toolbar-tab-changed', value)
    }
  },
  computed: {
    showLoading () {
      return typeof this.loading !== 'undefined' && this.loading !== false && this.loading !== ''
    },
    loadingText () {
      if (this.showLoading) {
        return this.loading
      } else {
        return ''
      }
    },
    width () {
      if (this.showLoading) return '400px'
      else if (this.size === 'x-large') return '1280px'
      else if (this.size === 'large') return '960px'
      else if (this.size === 'small') return '400px'
      else return '600px'
    }
  },
  methods: {
    open (params) {
      this.$services.clicky.logOpenDialog(this.name)
      this.dialogVisible = true
      this.$emit('open', params)
    },
    close (params) {
      this.$emit('close', params)
      this.$reset()
    },
    getCardClasses () {
      const classes = ['card-content']

      if (this.showLoading) classes.push('card-content-loading')

      if (this.dense === true) classes.push('card-content-dense')
      if (this.dense === 'mobile') classes.push('card-content-dense-mobile')

      return classes.join(', ')
    },
    handleVisibleProp () {
      if (this.visible === true && this.dialogVisible === false) {
        this.open()
      } else if (this.visible === false && this.dialogVisible === true) {
        this.close()
      }
    }
  },
  mounted () {
    this.$bus.on('dialog/' + this.name + '/open', this.open)
    this.$bus.on('dialog/' + this.name + '/close', this.close)

    this.handleVisibleProp()
  },
  destroyed () {
    this.$bus.off('dialog/' + this.name + '/open', this.open)
    this.$bus.off('dialog/' + this.name + '/close', this.close)
  }
}
</script>

<style>
@media screen and (max-width: 960px) {
  .a-dialog-card .card-content-dense-mobile {
    padding: 0 8px !important;
  }
}

.a-dialog-card .card-content-dense {
  padding: 0 8px !important;
}
</style>